import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { BodySmall, BodySmallMedium } from '../styles/Typography'
import { useTranslation } from 'react-i18next'
import { ScreeningType } from '@estercare/ester-shared'
import { Ping } from '../icons/Ping'
import { selectLatestScreeningDateByType, useSelectScreenings } from '../../state/selectors'

export const NewRecommendationsBanner = ({
  compact,
  variant = 'default',
}: {
  compact?: boolean
  variant?: 'default' | 'summary'
}) => {
  const { t, i18n } = useTranslation()
  const screenings = useSelectScreenings()
  const followUpDate = selectLatestScreeningDateByType(screenings, ScreeningType.FOLLOW_UP)
  const formattedFollowUpDate = followUpDate
    ? new Date(followUpDate).toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' })
    : null
  const showFollowUpDate = variant === 'default' && !compact && !!formattedFollowUpDate
  const titleKey =
    variant === 'summary' ? 'employee.yourHealth.followUpSummaryUpdated' : 'employee.yourHealth.followUpUpdated'

  return (
    <Container $compact={compact}>
      <PingWrapper>
        <Ping />
      </PingWrapper>
      <TextWrapper>
        <BodySmallMedium>{t(titleKey)}</BodySmallMedium>
        {showFollowUpDate && (
          <StyledBodySmall>
            {t('employee.yourHealth.followUpUpdatedDate', { date: formattedFollowUpDate })}
          </StyledBodySmall>
        )}
      </TextWrapper>
    </Container>
  )
}

const Container = styled.div<{ $compact?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ $compact }) => ($compact ? theme.spacing.xsmall : theme.spacing.medium)}px;
  background-color: ${theme.color.greenLight};
  padding: ${({ $compact }) =>
    $compact
      ? `${theme.spacing.tiny}px ${theme.spacing.xsmall}px`
      : `${theme.spacing.xsmall}px ${theme.spacing.medium}px`};
  color: ${theme.color.greenDark};
  border-radius: ${theme.spacing.small}px;
  border-left: 3px solid ${theme.color.green};
  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    width: 100%;
  }
`

const PingWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 4px;
  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    gap: 0;
  }
`

const StyledBodySmall = styled(BodySmall)`
  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    display: none;
  }
`
